import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, NavigationExtras } from '@angular/router';
import { PermissionService } from './permission.service';
import { PermissionDelivery } from './options/permissionDelivery';
import { PermissionOption } from './models/permissionOption.interface';
import { muPublicAccess } from 'src/environments/constants';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard  {
  permissionDelivery: PermissionOption[] = PermissionDelivery;

  constructor(private permissionService: PermissionService, private router: Router) {
    /** */
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    if (muPublicAccess.filter(p => p.address === state.url).length > 0)
    {
      return true;
    }
    const canAccess = await this.permissionService.canAccess(state.url);
    if (!canAccess) {
      const navigationExtras: NavigationExtras = { state: { data: state.url } };
      this.router.navigate(['/acceso-denegado-modulo'], navigationExtras);
    }
    return canAccess;
  }
}
